/**
 * ノートHTMLのインターネット公開契約。正本: functions/src/publicPages/htmlPublish.ts
 *
 * - enabled === true → ON
 * - それ以外（false / 未設定 / ドキュメントなし）→ OFF
 */

export const HTML_PUBLISH_SETTINGS_ID = 'htmlPublish';

export function htmlPublishDocPath(workspaceId: string): string {
  return `publicPages/${workspaceId}/settings/${HTML_PUBLISH_SETTINGS_ID}`;
}

export function isHtmlPagesEnabledFromData(
  data: { enabled?: unknown } | null | undefined
): boolean {
  return data?.enabled === true;
}
